import Button from 'components/buttons/Button';
import { BodyLarge, BodyRegular, FlexAlignCenter, FlexCol, FlexLgAlignCenter } from 'components/Elements';
import { ImageCircle } from 'components/ImageCircle';
import { LearnerCardBase } from 'pages/learner/sharedStyles/LearnerStyles';
import styled from 'styled-components';
import { breakpoints, sizes, theme } from 'theme';
import strings from '../../../strings/strings.json';
import { useNavigate } from 'react-router-dom';

type TrainerAndOrgProps = {
    orgName: string;
    orgPublicName: string;
    orgDescription: string | null;
    trainerFirstName: string;
    trainerLastName: string;
    trainerBio: string | null;
    trainerProfileImageFilepath: string;
};

export default function TrainerAndOrg({
    orgName,
    orgPublicName,
    orgDescription,
    trainerFirstName,
    trainerLastName,
    trainerBio,
    trainerProfileImageFilepath,
}: TrainerAndOrgProps) {
    const navigate = useNavigate();

    const viewOrganisationPageButton = (
        <Button
            title={strings.publicCoursePage.organisationSection.viewOrganisationButton.title}
            aria={strings.publicCoursePage.organisationSection.viewOrganisationButton.aria}
            onClick={() => {
                navigate(`/public/organisation/${orgPublicName}`);
            }}
        />
    );

    return (
        <TrainerAndOrgContainer>
            <TrainerContainer>
                <TrainerImageAndName>
                    <ImageCircle $imageurl={trainerProfileImageFilepath} />
                    <TrainerNameBlueText $bold>{`${trainerFirstName} ${trainerLastName}`}</TrainerNameBlueText>
                </TrainerImageAndName>
                {trainerBio && <BodyRegular>{trainerBio}</BodyRegular>}
            </TrainerContainer>
            <OrgTitleAndButton>
                <TrainerNameBlueText $bold>{orgName}</TrainerNameBlueText>
                {viewOrganisationPageButton}
            </OrgTitleAndButton>
            {orgDescription && <BodyRegular>{orgDescription}</BodyRegular>}
        </TrainerAndOrgContainer>
    );
}

const OrgTitleAndButton = styled(FlexLgAlignCenter)`
    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column;
        gap: 16px;
    }
`;

const TrainerContainer = styled(FlexCol)`
    padding-bottom: ${sizes.spacingMd};
    width: 100%;
    gap: ${sizes.spacingSm};
    border-bottom: 1px solid ${theme.secondaryButtonDisabledBackgroundColour};
`;

const TrainerImageAndName = styled(FlexAlignCenter)`
    gap: ${sizes.spacingMd};
`;

const TrainerNameBlueText = styled(BodyLarge)`
    color: ${theme.footerBackground};
`;

const TrainerAndOrgContainer = styled(LearnerCardBase)`
    padding: ${sizes.spacingMd};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: ${sizes.spacingMd};
    word-break: break-word;
`;
